import { IApplicationState } from '../../types/redux';

export const animationShownCountSelector = (state: IApplicationState): number => {
  return state.consultantCianChat.animationShownCount;
};
